<template>
	<div class='stepper'>
		<div class="button-primary sub" @click="modify(-1)">
			<Icon type="md-remove"/>
		</div>
		<div class="detailInput" size='small'>{{value}}</div>
		<div class="button-primary add" @click="modify(1)">
			<Icon type="md-add" />
		</div>
	</div>
</template>

<script>
import {
	mapState,
	mapMutations,
	mapActions
} from 'vuex'
export default {
	data() {
		return {
		}
	},
	created() {
		this.$nextTick(function() {
			this.initData()
		})
	},
	props:{
		value:{
			type:Number,
			default:0,
		},
		min:{
			type:Number,
			default:-Infinity,
		},
		max:{
			type:Number,
			default:Infinity,
		},
	},
	mounted() {

	},
	watch:{

	},
	mixins:[],
	components: {

	},
	computed: {
		...mapState({

		}),
	},
	methods: {
		...mapActions([
			
		]),
		async initData(){

		},
		modify(factor){
			let value = this.value+factor;
			if (value >= this.min && value <= this.max) {
				this.$emit('input',this.value,factor);
			}
		},
	},
}
</script>

<style lang='scss' scoped>
@import "@/style/common";
.stepper {
	display:flex;
	align-items: center;
	height: 25px;
	// gap:5px;
	.detailInput {
		min-width: 30px;
		height:25px;
		padding:0 3px;
		// border:1px solid #eee;
		font-size: 13px;
		line-height: 25px;
		text-align: center;
	}
	.sub,.add {
		color: white;
		width: 25px;
		height: 25px;
		text-align: center;
		display:flex;
		align-items: center;
		border-radius: 5px;
		.add_icon {
			position: relative;
			z-index: 9;
		}
		.cart_button {
			display: flex;
			align-items: center;
		}
		.icon {
			@include wh(25px,25px);
			fill: #3190e8;
		}
	}
}
</style>